import { body, isMobileMq } from './utils.js';

export function megaMenuReset() {
	const openMegaMenu = document.querySelector('.mega-menu--open');
	if (openMegaMenu) {
		openMegaMenu.classList.remove('mega-menu--open');
		body.classList.remove('mega-menu-open');
	}
}

export function megaMenuInit () {
	const menuTriggers = Array.from(
		document.querySelectorAll('.mega-menu-trigger')
	);

	if ( ! menuTriggers.length > 0 ) {
		return;
	}

	// Close mega menus on click outside on desktop.
	window.addEventListener( 'click', function (e) {
		const openMegaMenu = document.querySelector('.mega-menu--open');

		if (
			!isMobileMq.matches
				&& openMegaMenu
				&& e.target != openMegaMenu
				&& !openMegaMenu.contains(e.target)
				&& !e.target.classList.contains('mega-menu-trigger')
				&& !e.target.parentNode.classList.contains('mega-menu-trigger')
		) {
			megaMenuReset();
		}
	});

	menuTriggers.forEach(function (trigger) {

		// Mega Menu triggered to open.
		const megaMenuParent = trigger.parentElement;

		trigger.addEventListener('click', function (e) {
			e.preventDefault();

			if ( megaMenuParent.classList.contains('mega-menu--open') ) {
				megaMenuReset();
			} else {
				megaMenuReset();
				megaMenuParent.classList.add('mega-menu--open');
				body.classList.add('mega-menu-open');
			}
		});
	});
};
